const _this = {

    $dom: {
		
    },

    vars: {
		
	},

    init : function() {
        this.map();
    },

    map: function() {
        var activeIndex = $('.active-tab').index(),
        $contentlis = $('.tab-panel'),
        $tabslis = $('.tabs--control__item');
    
        // Show content of active tab on loads
        $contentlis.eq(activeIndex).show();
    
        $('.tabs--control').on('click', '.tabs--control__item', function (e) {
            var $current = $(e.currentTarget),
                index = $current.index();
            
            $tabslis.removeClass('active-tab');
            $current.addClass('active-tab');
            $contentlis.hide().eq(index).show();
        });
	}
}

export default _this;